export const CRATE_LOOKUP_TEXT = Object.freeze({
  nl: {
    nav: "Kist opzoeken",
    title: "Kist opzoeken",
    scanInTab: "Kisten inscannen",
    lookupTab: "Kist opzoeken",
    scanInIntro: "Volg de geplande partij en rij, en scan normale of houten kisten met de telefooncamera.",
    scanCrate: "Kist scannen met camera",
    processingScan: "Scan verwerken...",
    scanFailed: "De scan kon niet worden verwerkt. Probeer opnieuw.",
    intro: "Scan de QR-code op een kist om de broccoli-gegevens te bekijken.",
    openCamera: "Camera openen",
    stopCamera: "Camera sluiten",
    scanAgain: "Kist opzoeken",
    cameraHint: "Richt de camera op de QR-code van de kist.",
    loading: "Kistgegevens laden...",
    invalidCode: "Deze QR-code is geen geldig kistnummer.",
    notFound: "Deze kist staat niet in de actuele voorraad.",
    lookupFailed: "De kistgegevens konden niet worden geladen.",
    cameraUnavailable: "De camera kon niet worden geopend. Controleer de cameratoestemming en probeer opnieuw.",
    desktopOnly: "De kistscanner is alleen beschikbaar op een telefoon.",
    resultTitle: "Broccoli in deze kist",
    crate: "Kist",
    scannedAt: "Datum ingescand",
    field: "Perceel",
    variety: "Soort",
    weight: "Gewicht",
    cuttingGroup: "Snijgroep",
    coolingCell: "Koelcel",
    row: "Rij",
    cratesInRow: "Kisten in deze rij",
    matchingCrates: "Gelijke kisten in alle koelcellen",
    matchingCratesHint: "Zelfde perceel, soort, gewicht en inscandatum",
    countsUnavailable: "De aantallen zijn tijdelijk niet beschikbaar. De overige kistgegevens zijn wel actueel.",
    unknown: "Onbekend",
  },
  en: {
    nav: "Look up crate",
    title: "Look up crate",
    scanInTab: "Scan in crates",
    lookupTab: "Look up crate",
    scanInIntro: "Follow the planned batch and row, and scan plastic or wooden crates with your phone camera.",
    scanCrate: "Scan crate with camera",
    processingScan: "Processing scan...",
    scanFailed: "The scan could not be processed. Please try again.",
    intro: "Scan the QR code on a crate to view its broccoli details.",
    openCamera: "Open camera",
    stopCamera: "Close camera",
    scanAgain: "Look up crate",
    cameraHint: "Point the camera at the crate's QR code.",
    loading: "Loading crate details...",
    invalidCode: "This QR code is not a valid crate number.",
    notFound: "This crate is not in the current inventory.",
    lookupFailed: "The crate details could not be loaded.",
    cameraUnavailable: "The camera could not be opened. Check camera permission and try again.",
    desktopOnly: "The crate scanner is only available on a phone.",
    resultTitle: "Broccoli in this crate",
    crate: "Crate",
    scannedAt: "Scan-in date",
    field: "Field",
    variety: "Variety",
    weight: "Weight",
    cuttingGroup: "Cutting group",
    coolingCell: "Cooling cell",
    row: "Row",
    cratesInRow: "Crates in this row",
    matchingCrates: "Matching crates in all cooling cells",
    matchingCratesHint: "Same field, variety, weight and scan-in date",
    countsUnavailable: "The counts are temporarily unavailable. The other crate details are current.",
    unknown: "Unknown",
  },
  pl: {
    nav: "Wyszukaj skrzynię",
    title: "Wyszukaj skrzynię",
    scanInTab: "Przyjmij skrzynie",
    lookupTab: "Wyszukaj skrzynię",
    scanInIntro: "Postępuj zgodnie z zaplanowaną partią i rzędem. Skanuj plastikowe lub drewniane skrzynie kamerą telefonu.",
    scanCrate: "Zeskanuj skrzynię kamerą",
    processingScan: "Przetwarzanie skanu...",
    scanFailed: "Nie udało się przetworzyć skanu. Spróbuj ponownie.",
    intro: "Zeskanuj kod QR na skrzyni, aby zobaczyć dane brokułów.",
    openCamera: "Otwórz kamerę",
    stopCamera: "Zamknij kamerę",
    scanAgain: "Wyszukaj skrzynię",
    cameraHint: "Skieruj kamerę na kod QR skrzyni.",
    loading: "Ładowanie danych skrzyni...",
    invalidCode: "Ten kod QR nie zawiera prawidłowego numeru skrzyni.",
    notFound: "Tej skrzyni nie ma w aktualnym stanie magazynowym.",
    lookupFailed: "Nie udało się załadować danych skrzyni.",
    cameraUnavailable: "Nie udało się uruchomić kamery. Sprawdź uprawnienia kamery i spróbuj ponownie.",
    desktopOnly: "Skaner skrzyń jest dostępny tylko na telefonie.",
    resultTitle: "Brokuły w tej skrzyni",
    crate: "Skrzynia",
    scannedAt: "Data przyjęcia",
    field: "Pole",
    variety: "Odmiana",
    weight: "Waga",
    cuttingGroup: "Grupa cięcia",
    coolingCell: "Chłodnia",
    row: "Rząd",
    cratesInRow: "Skrzynie w tym rzędzie",
    matchingCrates: "Takie same skrzynie we wszystkich chłodniach",
    matchingCratesHint: "To samo pole, odmiana, waga i data przyjęcia",
    countsUnavailable: "Liczby są tymczasowo niedostępne. Pozostałe dane skrzyni są aktualne.",
    unknown: "Nieznane",
  },
});
